(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-product-option]')) return;
    var root = event.target.closest('[data-product-root]');
    var values = Array.from(root.querySelectorAll('[data-option-position]')).map(function (group) {
      var checked = group.querySelector('[data-product-option]:checked');
      return checked ? checked.value : null;
    });
    var variantsNode = root.querySelector('[data-product-variants]');
    var variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    var variant = variants.find(function (item) {
      return item.options.every(function (value, index) { return value === values[index]; });
    });
    var variantInput = root.querySelector('[data-variant-id]');
    var button = root.querySelector('[data-add-button]');
    var label = root.querySelector('[data-add-label]');
    if (!variant) {
      button.disabled = true;
      label.textContent = root.dataset.soldOutLabel;
      return;
    }
    variantInput.value = variant.id;
    root.querySelector('[data-product-price]').textContent = variant.price;
    button.disabled = !variant.available;
    label.textContent = variant.available ? root.dataset.addLabel : root.dataset.soldOutLabel;
  });

  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var gallery = root.querySelector('[data-product-gallery]');
    var previous = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    var count = root.querySelector('[data-gallery-count]');
    if (!gallery || !previous || !next || !count) return;
    var total = gallery.children.length;
    function currentIndex() { return Math.round(gallery.scrollLeft / gallery.clientWidth); }
    function goTo(index) { gallery.scrollTo({ left: Math.max(0, Math.min(total - 1, index)) * gallery.clientWidth, behavior: 'smooth' }); }
    previous.addEventListener('click', function () { goTo(currentIndex() - 1); });
    next.addEventListener('click', function () { goTo(currentIndex() + 1); });
    gallery.addEventListener('scroll', function () { count.textContent = (currentIndex() + 1) + ' / ' + total; }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  function headerDisclosures() {
    return Array.from(document.querySelectorAll('.gallery-header__mobile, .gallery-header__shop, .gallery-header__mobile-language-trigger details'));
  }

  document.addEventListener('toggle', function (event) {
    var disclosures = headerDisclosures();
    if (!event.target.open || !disclosures.includes(event.target)) return;
    disclosures.forEach(function (details) {
      if (details !== event.target) details.open = false;
    });
  }, true);

  document.addEventListener('click', function (event) {
    headerDisclosures().forEach(function (details) {
      if (details.open && (!details.contains(event.target) || event.target.closest('a'))) details.open = false;
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    headerDisclosures().forEach(function (details) {
      if (!details.open) return;
      details.open = false;
      details.querySelector('summary').focus({ preventScroll: true });
      event.preventDefault();
    });
  });

  window.matchMedia('(max-width: 1040px)').addEventListener('change', function () {
    headerDisclosures().forEach(function (details) { details.open = false; });
  });

  } catch(e) { console.error(e); }
})();
})();
